<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    role="presentation"
  >
    <g :fill="iconColor">
      <icon-border-bottom v-if="iconName === 'border-bottom'" />
      <icon-border-top v-else-if="iconName === 'border-top'" />
      <icon-border-right v-else-if="iconName === 'border-right'" />
      <icon-border-left v-else-if="iconName === 'border-left'" />
      <icon-border-none v-else-if="iconName === 'border-none'" />
      <icon-border-all v-else-if="iconName === 'border-all'" />
      <icon-border-outer v-else-if="iconName === 'border-outer'" />
      <icon-text v-else-if="iconName === 'text'" />
      <icon-format-clear v-else-if="iconName === 'format-clear'" />
      <icon-line-weight v-else-if="iconName === 'line-weight'"/>
      <icon-border-color v-else-if="iconName === 'border-color'"/>
      <icon-arrow v-else-if="iconName === 'arrow'"/>
      <icon-left-right-arrow v-else-if="iconName === 'left-right-arrow'"/>
      <icon-double-line-arrow v-else-if="iconName === 'double-line-arrow'"/>
      <icon-line v-else-if="iconName === 'line'"/>
      <icon-double-arrow v-else-if="iconName === 'double-arrow'"/>
      <icon-align-bottom v-else-if="iconName === 'align-bottom'"/>
      <icon-align-middle v-else-if="iconName === 'align-middle'"/>
      <icon-align-top v-else-if="iconName === 'align-top'"/>
      <icon-border-all-small v-else-if="iconName === 'border-all-small'"/>
      <icon-column v-else-if="iconName === 'column'"/>
      <icon-textWrap v-else-if="iconName === 'textWrap'"/>
    </g>
  </svg>
</template>

<script>
import iconBorderBottom from './iconBorderBottom'
import iconBorderLeft from './iconBorderLeft'
import iconBorderRight from './iconBorderRight'
import iconBorderNone from './iconBorderNone'
import iconBorderTop from './iconBorderTop'
import iconBorderAll from './iconBorderAll'
import iconBorderOuter from './iconBorderOuter'
import iconText from './iconText'
import iconFormatClear from './iconFormatClear'
import iconLineWeight from './iconLineWeight'
import iconBorderColor from './iconBorderColor'
import iconArrow from './iconArrow'
import iconLeftRightArrow from './iconLeftRightArrow'
import iconDoubleLineArrow from './iconDoubleLineArrow'
import iconLine from './iconLine'
import iconDoubleArrow from './iconDoubleArrow'
import iconAlignBottom from './iconAlignBottom'
import iconAlignMiddle from './iconAlignMiddle'
import iconAlignTop from './iconAlignTop'
import iconBorderAllSmall from './iconBorderAllSmall'
import iconColumn from './iconColumn'
import iconTextWrap from './iconTextWrap'

export default {
  components: {
    iconBorderBottom,
    iconBorderLeft,
    iconBorderRight,
    iconBorderNone,
    iconBorderTop,
    iconBorderAll,
    iconText,
    iconFormatClear,
    iconBorderOuter,
    iconLineWeight,
    iconBorderColor,
    iconArrow,
    iconLeftRightArrow,
    iconDoubleLineArrow,
    iconLine,
    iconDoubleArrow,
    iconAlignBottom,
    iconAlignMiddle,
    iconAlignTop,
    iconBorderAllSmall,
    iconColumn,
    iconTextWrap
  },
  props: {
    iconName: {
      type: String,
      default: 'border-none'
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/icons/iconBase.vue